import type { BlockTimeLine, SingleTimeline } from 'types/block-timeline';
import { Paragraph, Wrap } from '@leafwell/components';
import HeadingBody from './heading-body';
import Figure from './figure';

const TimelineItem: React.FC<SingleTimeline> = ({
  color,
  title,
  content,
  image,
}) => {
  let textColor: string;

  if (color === 'secondary') {
    textColor = 'text-lilac-300';
  } else if (color === 'tertiary') {
    textColor = 'text-yellow-500';
  } else {
    textColor = 'text-green';
  }

  return (
    <li
      className={[
        'relative pl-10 lg:pl-0 lg:pt-10 grid gap-1 lg:gap-3',
        'before:absolute before:w-4 before:h-4 before:bg-current before:rounded-full before:-left-2 before:lg:left-0 before:lg:-mt-2 before:top-0',
        textColor,
      ].join(' ')}
    >
      <Figure
        {...image}
        className="w-10 h-10"
        classNameImage="lg:object-left-bottom"
        objectFit="contain"
      />
      <Paragraph dangerouslySetInnerHTML={{ __html: title }} size="large" />
      <Paragraph
        className="text-black"
        dangerouslySetInnerHTML={{ __html: content }}
        size="small"
      />
    </li>
  );
};

const Timeline: React.FC<BlockTimeLine> = ({ title, timeline }) => {
  return (
    <Wrap>
      {title?.length > 0 && (
        <HeadingBody className="lg:text-center" level="4" title={title} />
      )}
      {timeline?.length > 0 && (
        <ul className="ml-2 lg:ml-0 grid lg:grid-flow-col lg:auto-cols-fr gap-6 xl:gap-x-16 border-l lg:border-l-0 lg:border-t border-indigo-200 items-start">
          {timeline.map((item, index) => (
            <TimelineItem key={index} {...item} />
          ))}
        </ul>
      )}
    </Wrap>
  );
};

export default Timeline;
